import { TApplicationState } from '../../types/redux';

export const selectLayoutsIds = (state: TApplicationState) => {
  return state.catalog.layoutsIds;
};
